import { BlockMetaProvider, FCC, getFrontendTheme, useDynamicConfig } from "@dgs/core";
import { config } from "../config";
import { aspectRatios } from "./aspectRatioOptions";

const theme = getFrontendTheme(config.mode);

export const JarvisBlockMetaProvider: FCC = ({ children }) => {
	const { apiUrl, languageSettings } = useDynamicConfig();

	return (
		<BlockMetaProvider
			apiUrl={apiUrl}
			config={{ frontendTheme: theme, aspectRatioOptions: aspectRatios }}
			mode={config.mode}
			fallbackLocale={languageSettings.fallback}
			scopes="web"
		>
			{children}
		</BlockMetaProvider>
	);
};
